import styled from 'styled-components';

const Wrapper = styled.main`
  background: #f6f8f8;
  min-height: 100vh;

  /* Breadcrumb */
  .breadcrumb-section {
    background: #f0f4f4;
    padding: 1.5rem 0;
  }

  .breadcrumb {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #6b7280;

    a {
      color: #6b7280;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: #111718;
      }
    }

    span.current {
      color: #111718;
      font-weight: 500;
    }
  }

  /* Product Section */
  .product-section {
    max-width: 1280px;
    margin: 0 auto;
    padding: 3rem 1.5rem 4rem;
  }

  .product-center {
    display: grid;
    gap: 3rem;
  }

  @media (min-width: 1024px) {
    .product-center {
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
    }
  }

  /* Product Images */
  .product-images {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .main-image-container {
    position: relative;
    width: 100%;
    padding-bottom: 125%; /* aspect-ratio: 4 / 5 fallback */
    height: 0;
    overflow: hidden;
    border-radius: 0.75rem;
    background: #f0f0f0;
  }

  .main-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .badge {
    position: absolute;
    top: 1rem;
    left: 1rem;
    padding: 0.375rem 0.75rem;
    background: #ffffff;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #111718;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .thumbnail-gallery {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 0.75rem;
  }

  .thumbnail {
    position: relative;
    padding-bottom: 100%; /* aspect-ratio: 1 fallback */
    height: 0;
    overflow: hidden;
    border-radius: 0.5rem;
    cursor: pointer;
    border: 2px solid transparent;
    background: #f0f0f0;
    transition: all 0.2s;

    img {
      position: absolute;
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      object-fit: cover;
      border-radius: 0.375rem;
      opacity: 0.7;
      transition: opacity 0.2s;
    }

    &:hover img {
      opacity: 1;
    }

    &.active {
      border-color: #111718;
      
      img {
        opacity: 1;
      }
    }
  }

  /* Product Content */
  .content {
    display: flex;
    flex-direction: column;
  }

  .product-title {
    font-family: 'Playfair Display', serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #111718;
    margin: 0 0 0.75rem;
    line-height: 1.2;
  }

  @media (min-width: 768px) {
    .product-title {
      font-size: 3rem;
    }
  }

  .rating-section {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;

    .stars {
      display: flex;
      color: #eab308;
    }

    .review-count {
      font-size: 0.875rem;
      color: #6b7280;
    }
  }

  .price {
    font-size: 1.875rem;
    font-weight: 500;
    color: #111718;
    margin: 0;
  }

  .price-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }

  .old-price {
    font-size: 1rem;
    color: #9ca3af;
    text-decoration: line-through;
  }

  .discount-badge {
    font-size: 0.75rem;
    font-weight: 700;
    color: #dc2626;
    background: #fee2e2;
    padding: 0.25rem 0.45rem;
    border-radius: 0.35rem;
  }

  .product-info-section {
    padding-bottom: 2rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid #e5e7eb;
  }

  .desc {
    font-size: 1rem;
    line-height: 1.75;
    color: #6b7280;
    margin-bottom: 1.5rem;
  }

  /* Professional Product Specifications */
  .product-specs {
    background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f4 100%);
    border-radius: 12px;
    padding: 1.5rem;
    border: 1px solid #e5e7eb;
  }

  .specs-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.125rem;
    font-weight: 700;
    color: #111718;
    margin: 0 0 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #111718;
    display: inline-block;
  }

  .spec-item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 0.875rem 0;
    border-bottom: 1px solid #e5e7eb;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .spec-icon {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #111718;
    color: #ffffff;
    border-radius: 8px;
    font-size: 0.875rem;
    flex-shrink: 0;

    .color-icon {
      font-size: 1.25rem;
      background: linear-gradient(135deg, #ff6b6b, #4ecdc4, #45b7d1, #96c93d);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }

  .stock-icon {
    background: #16a34a;
  }

  .spec-content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    flex: 1;
  }

  .spec-label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #6b7280;
  }

  .spec-value {
    font-size: 1rem;
    font-weight: 600;
    color: #111718;

    &.in-stock {
      color: #16a34a;
    }

    &.out-of-stock {
      color: #dc2626;
    }
  }

  .spec-colors {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 0.25rem;
  }

  .spec-color-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    margin-right: 0.35rem;
  }

  .spec-color-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 3px solid #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    cursor: default;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.15);
    }
  }

  .spec-color-name {
    font-size: 0.75rem;
    color: #4b5563;
    font-weight: 600;
    text-transform: capitalize;
  }

  .info-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #111718;

    span {
      font-weight: 700;
      width: 100px;
    }

    .value {
      color: #6b7280;
      font-weight: 400;
    }

    .in-stock {
      color: #16a34a;
      font-weight: 500;
    }

    .out-of-stock {
      color: #dc2626;
      font-weight: 500;
    }
  }

  /* Product Options */
  .product-options {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .option-group {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .option-label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #111718;
  }

  /* Colors */
  .colors {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .color-btn {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    ring-offset: 2px;

    svg {
      font-size: 0.75rem;
      color: #ffffff;
    }

    &:hover {
      transform: scale(1.1);
    }

    &.active {
      box-shadow: 0 0 0 2px #111718, 0 0 0 4px #ffffff;
    }
  }

  .selected-color-label {
    font-size: 0.8rem;
    color: #4b5563;
    font-weight: 600;
  }

  .offers-list {
    display: grid;
    gap: 0.75rem;
  }

  .offer-option {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 0.625rem;
    background: #ffffff;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    cursor: pointer;
    text-align: left;
    transition: all 0.2s;

    &:hover {
      border-color: #7d9254;
    }

    &.active {
      border-color: #7d9254;
      box-shadow: 0 0 0 1px #7d9254;
      background: #f9fbf4;
    }
  }

  .offer-left {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .offer-title {
    font-size: 0.875rem;
    color: #111718;
    font-weight: 600;
  }

  .offer-shipping {
    font-size: 0.75rem;
    color: #6b7280;
  }

  .offer-right {
    font-size: 0.9rem;
    font-weight: 700;
    color: #111718;
  }

  /* Size Select */
  .size-select {
    width: 100%;
    max-width: 200px;
    padding: 0.75rem 1rem;
    padding-right: 2.5rem;
    appearance: none;
    background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") no-repeat right 0.75rem center;
    background-size: 1rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: #111718;
    cursor: pointer;
    transition: all 0.2s;

    &:focus {
      outline: none;
      border-color: #111718;
    }
  }

  /* Quantity */
  .quantity-selector {
    display: flex;
    align-items: center;
    width: fit-content;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    background: #ffffff;
    overflow: hidden;
  }

  .qty-btn {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    font-size: 1.25rem;
    color: #111718;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f3f4f6;
    }
  }

  .qty-value {
    width: 3rem;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 500;
    color: #111718;
  }

  /* Customer Form */
  .customer-form {
    background: #f9fafb;
    padding: 1.5rem;
    border-radius: 0.75rem;
    margin: 1.5rem 0;
    border: 1px solid #f3f4f6;

    h4 {
      font-family: 'Playfair Display', serif;
      font-size: 1.125rem;
      font-weight: 700;
      color: #111718;
      margin: 0 0 1rem;
    }
  }

  .order-summary {
    border: 1px solid #e5e7eb;
    border-radius: 0.75rem;
    background: #ffffff;
    padding: 1rem;
    display: grid;
    gap: 0.5rem;
    margin-bottom: 1.25rem;
  }

  .summary-row {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    color: #4b5563;
  }

  .summary-row.total {
    margin-top: 0.35rem;
    padding-top: 0.55rem;
    border-top: 1px solid #e5e7eb;
    font-weight: 700;
    color: #111718;
  }

  .form-grid {
    display: grid;
    gap: 1rem;
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  @media (max-width: 576px) {
    .form-row {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    label {
      font-size: 0.75rem;
      font-weight: 700;
      color: #6b7280;
    }

    input, select {
      width: 100%;
      padding: 0.625rem 0.75rem;
      background: #ffffff;
      border: 1px solid #d1d5db;
      border-radius: 0.375rem;
      font-size: 0.875rem;
      color: #111718;
      transition: all 0.2s;

      &:focus {
        outline: none;
        border-color: #111718;
      }

      &::placeholder {
        color: #9ca3af;
      }
    }
  }

  /* Action Buttons */
  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }

  .order-now-btn {
    width: 100%;
    padding: 1rem;
    background: #111718;
    color: #ffffff;
    font-size: 1rem;
    font-weight: 700;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

    &:hover {
      background: #000000;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      background: #9ca3af;
      cursor: not-allowed;
      box-shadow: none;
    }
  }

  .add-cart-btn {
    width: 100%;
    padding: 1rem;
    background: #e5e0d8;
    color: #5c5346;
    font-size: 1rem;
    font-weight: 700;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #dcd5cb;
    }
  }

  /* Reviews Section */
  .reviews-section {
    background: #ffffff;
    border-top: 1px solid #e5e7eb;
    padding: 4rem 0;
  }

  .reviews-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  .reviews-header {
    margin-bottom: 2.5rem;

    h3 {
      font-family: 'Playfair Display', serif;
      font-size: 1.875rem;
      font-weight: 700;
      color: #111718;
      margin: 0 0 0.5rem;
    }

    .reviews-summary {
      display: flex;
      align-items: center;
      gap: 1rem;

      .stars {
        display: flex;
        color: #eab308;
      }

      .rating-value {
        font-size: 1.125rem;
        font-weight: 700;
        color: #111718;
      }

      .review-count {
        color: #6b7280;
      }
    }
  }

  .reviews-grid {
    display: grid;
    gap: 1.5rem;
  }

  @media (min-width: 768px) {
    .reviews-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1024px) {
    .reviews-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .review-card {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1.5rem;
    background: #f9f9f9;
    border: 1px solid #f3f4f6;
    border-radius: 0.75rem;

    .review-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .stars {
        display: flex;
        color: #eab308;
        font-size: 0.875rem;
      }

      .date {
        font-size: 0.75rem;
        color: #6b7280;
      }
    }

    .review-title {
      font-weight: 700;
      color: #111718;
      margin: 0;
    }

    .review-text {
      font-size: 0.875rem;
      line-height: 1.6;
      color: #6b7280;
      margin: 0;
    }

    .reviewer {
      margin-top: auto;
      padding-top: 0.5rem;
      font-size: 0.75rem;
      font-weight: 500;
      color: #6b7280;

      .verified {
        color: #16a34a;
        margin-left: 0.25rem;
      }
    }
  }

  .no-reviews {
    text-align: center;
    padding: 3rem;
    color: #6b7280;
    font-size: 1rem;
  }

  .review-modal-btn {
    margin-top: 2rem;
    text-align: center;
  }

  /* Back Button */
  .back-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 1.25rem;
    background: transparent;
    color: #111718;
    font-size: 0.875rem;
    font-weight: 500;
    text-decoration: none;
    border: 1px solid #111718;
    border-radius: 0.5rem;
    transition: all 0.2s;
    margin-bottom: 2rem;

    &:hover {
      background: #111718;
      color: #ffffff;
    }
  }

  /* Out of stock message */
  .out-of-stock-message {
    padding: 2rem;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 0.75rem;
    text-align: center;
    color: #dc2626;
    font-weight: 500;
  }
`;

export default Wrapper;
